import { sendRequest } from "../request";
const BASE_URL = '/api/subClients';

export function createSubClient(userID, clientID, subClientData){
    return sendRequest(`${BASE_URL}/${clientID}/newSubClient/${userID}`, "POST", subClientData, 'Unable to create sub-client!')
}

export function getClientSubClients(userID, clientID){
    return sendRequest(`${BASE_URL}/client/${clientID}/subClients/${userID}`, "GET", null, 'Unable to retrieve sub-clients!')
}

export function updateSubClientAccess(userID, subClientID, subClientData){
    return sendRequest(`${BASE_URL}/${subClientID}/updateSubClientAccess/${userID}`, "PUT", subClientData, 'Unable to update sub-client!')
}

export function deleteSubClient(userID, subClientID){
    return sendRequest(`${BASE_URL}/${subClientID}/${userID}`, "DELETE", null, 'Unable to delete sub-client!')
}